module.exports = __webpack_public_path__ + "assets/img/favicon/android-icon-72x72.1a5ae6e5364cc6f467b391de53c02ddc.png";